// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"_9608829","small":"_46d254d"};